import React, { Component } from "react";
import { observer } from "mobx-react";

import { IDevice } from "@formant/core/model/IDevice";
import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { Fader } from "@formant/ui/component/common/Fader";

import {
    appStore,
    operateStore,
    organizationStore,
    routerStore,
} from "../../../stores";
import { DeviceMenu } from "../../common/DeviceMenu";
import { FlexSpacer } from "../../common/FlexSpacer";
import { ConnectedTeleopArmSwitch } from "../../Teleop/ConnectedTeleopArmSwitch";
import { ExitButton } from "../../Teleop/ExitButton";
import { TeleopAudioPlayer } from "../../Teleop/TeleopAudioPlayer";
import { TeleopLockDeviceSwitch } from "../../Teleop/TeleopLockDeviceSwitch";
import { TeleopLowBandwidthModeSwitch } from "../../Teleop/TeleopLowBandwidthModeSwitch";
import { PulseBar } from "../PulseBar";
import { GamepadIndicator } from "./GamepadIndicator";
import * as styles from "./index.scss";

export interface IToolbarProps {
    configuration?: IDeviceTeleopConfiguration;
    device: IDevice;
}
@observer
export class Toolbar extends Component<IToolbarProps> {
    public render() {
        const { session } = operateStore;
        const { preview } = appStore;
        const { configuration } = this.props;

        if (!configuration) {
            return false;
        }

        return (
            <Fader
                visible={!!configuration}
                className={styles.toolbar}
                slow={true}
            >
                {!preview && <ExitButton onExit={this.toDevicePage} />}
                <FlexSpacer />
                <PulseBar
                    configuration={configuration}
                    className={styles.pulse}
                />
                <FlexSpacer />
                <GamepadIndicator
                    configuration={configuration?.joysticks?.[0]}
                />
                <TeleopAudioPlayer configuration={configuration} />
                <ConnectedTeleopArmSwitch configuration={configuration} />
                {organizationStore.getDeviceLocksEnabled() && (
                    <TeleopLockDeviceSwitch />
                )}
                <TeleopLowBandwidthModeSwitch configuration={configuration} />
                {session?.deviceId && !preview && (
                    <DeviceMenu
                        deviceId={session?.deviceId}
                        hasTimeline={true}
                        mode="operate"
                    />
                )}
            </Fader>
        );
    }

    private toDevicePage = async () => {
        const { session } = operateStore;
        const id = session?.deviceId;
        const { navigate, routeTo } = routerStore;
        if (id) {
            await navigate(routeTo.device({ id }));
        }
    };
}
